module.exports = __webpack_public_path__ + "img/bgIcon_11.d9a68354.png";